/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Icon from '../../../components/Icon';
import SidePanel from '../../../components/SidePanel';
import Tabs from '../../../components/Tabs';
import Tab from '../../../components/Tabs/Tab';

import Manifest from './Manifest';
import History from './History';
import Receipts from './Receipts';
import Ctes from './Ctes';
import Occurrences from './Occurrences';
import ManifestMap from './ManifestMap';

import { getManifest } from '../../../redux/manifest';

import './styles.css';
import LoadingIndicator from '../../../components/LoadingIndicator';

import { luftGet } from '../../../shared/http';

export const detailsTabs = {
  MANIFEST: 'manifest',
  FORECAST_HISTORY: 'forecast_history',
  RECEIPTS: 'receipts',
  CTES: 'ctes',
  OCCURRENCES: 'occurrences',
  MANIFEST_MAP: 'manifestMap',
};

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: detailsTabs.MANIFEST,
      manifestInformation: {},
    };
  }

  async componentWillMount() {
    this.props.getManifest({ manifestId: this.props.currentManifestId });
    await this._getManifestsCheckpoints();
  }

  _getManifestsCheckpoints = async () => {
    try {
      this.setState(prevState => ({
        manifestInformation: {
          ...prevState,
          isFetching: true,
        },
      }));

      const response = await luftGet('/OnTime/GetManifestCheckpoints', { manifestId: this.props.currentManifestId });

      const {
        data: {
          deliveries,
          driver,
        },
      } = response;

      const {
        checkpoints,
      } = driver;

      this.setState({
        manifestInformation: {
          driver,
          deliveries,
          checkpoints,
          isFetching: false,
        },
      });
    } catch (error) {
      console.log(error);
    }
  }

  _quantityOfCtes = () => {
    let quantity = 0;

    if (this.props.currentManifest) {
      quantity = this.props.currentManifest.deliveries.length;
    }

    return ` (${quantity})`;
  }

  _changeTab = (currentTab) => {
    this.setState({ currentTab });
  }

  // _fetchGoogleMaps = () => {}

  _renderContent = () => {
    const {
      currentTab,
      manifestInformation,
    } = this.state;
    const {
      currentManifest,
      isFetching,
    } = this.props;

    if (currentTab === detailsTabs.MANIFEST_MAP) {
      if (manifestInformation.isFetching) {
        return (<LoadingIndicator
          text="Carregando..."
          theme="dark"
          className="NotificationSettingsModal__loading-indicator"
        />);
      }

      return (
        <ManifestMap
          currentManifest={currentManifest}
          manifestInformation={manifestInformation}
        />
      );
    }

    if (isFetching) {
      return (
        <LoadingIndicator
          text="Carregando..."
          theme="dark"
          className="NotificationSettingsModal__loading-indicator"
        />);
    }


    if (currentManifest) {
      if (currentTab === detailsTabs.MANIFEST) {
        return (
          <Manifest currentManifest={currentManifest} />
        );
      }

      if (currentTab === detailsTabs.FORECAST_HISTORY) {
        return (
          <History currentManifest={currentManifest} />
        );
      }

      if (currentTab === detailsTabs.CTES) {
        return (
          <Ctes currentManifest={currentManifest} />
        );
      }

      if (currentTab === detailsTabs.OCCURRENCES) {
        return (
          <Occurrences currentManifest={currentManifest} />
        );
      }


      return (
        <Receipts currentManifest={currentManifest} />
      );
    }
  }

  render() {
    const { onDismiss } = this.props;
    const { currentTab } = this.state;

    return (
      <SidePanel onDismiss={onDismiss}>
        <div className="TrackingDetails">
          <div className="TrackingDetails__header">
            <div className="TrackingDetails__toolbar">
              <Icon
                className="TrackingDetails__close-modal-mobile"
                name="close"
                onClick={onDismiss}
              />
              <h3 className="TrackingDetails__toolbar-title">Detalhes do manifesto</h3>
            </div>
          </div>
          <Tabs className="TrackingDetails__tabs">
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.MANIFEST); }}
              isActive={currentTab === detailsTabs.MANIFEST}
            >
              Manifesto
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.CTES); }}
              isActive={currentTab === detailsTabs.CTES}
            >
              CTEs{this._quantityOfCtes()}
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.OCCURRENCES); }}
              isActive={currentTab === detailsTabs.OCCURRENCES}
            >
              Ocorrências
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.FORECAST_HISTORY); }}
              isActive={currentTab === detailsTabs.FORECAST_HISTORY}
            >
              Histórico de Previsão
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.RECEIPTS); }}
              isActive={currentTab === detailsTabs.RECEIPTS}
            >
              Fotos e Comprovantes
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => { this._changeTab(detailsTabs.MANIFEST_MAP); }}
              isActive={currentTab === detailsTabs.MANIFEST_MAP}
            >
              Mapa
            </Tab>
          </Tabs>
          { this._renderContent() }
        </div>
      </SidePanel>
    );
  }
}

const mapStateToProps = state => ({
  currentManifest: state.manifest.list,
  isFetching: state.manifest.isFetching,
});

const mapActionToProps = {
  getManifest,
};

export default connect(mapStateToProps, mapActionToProps)(Details);
